import type { FieldValues } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';

import { MonitoringApi } from 'api';
import { BANK_OMIT_TRANSACTIONS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useUpdateOmitTransactions() {
  const { userBankId } = useUser();
  const monitoringApi = new MonitoringApi();

  const {
    mutate: updateOmitTransactions,
    isPending: isLoadingUpdateOmitTransactions,
    isSuccess: isSuccessUpdateOmitTransactions
  } = useMutation({
    mutationKey: [BANK_OMIT_TRANSACTIONS_KEY],
    mutationFn: (newData: FieldValues) => {
      return monitoringApi.omitTransactions(
        userBankId,
        newData.transactionIds,
        newData.comment,
        newData.omit,
        newData.reviewId
      );
    },
    onSuccess: (_data) => {
      // TODO: When monitoring report is refactored to tanstack query we will want to update the monitoring report cache here
    },
    meta: {
      snackbarErrorMessage: 'An error has occurred updating transactions.  Please contact support.'
    }
  });
  return { updateOmitTransactions, isLoadingUpdateOmitTransactions, isSuccessUpdateOmitTransactions };
}
